var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"quillEdit"}),_c('input',{ref:"quillEditImage",staticClass:"form-control d-none",attrs:{"type":"file","accept":"image/png, image/jpeg"},on:{"change":function($event){return _vm.onFileChange()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }